import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type TypeLoadingStore = {
  show: boolean;
  dimmed: boolean;
  zIndex: number;
  actions: {
    setLoading: ({ show, dimmed, zIndex }: { show: boolean; dimmed?: boolean; zIndex?: number }) => void;
  };
};

const initialState: Pick<TypeLoadingStore, 'show' | 'dimmed' | 'zIndex'> = {
  show: false,
  dimmed: true,
  zIndex: 3999,
};

/** @description 전역 로딩 인디케이터에 사용되는 로딩 상태 */
export const useLoadingStore = create<TypeLoadingStore>()(
  devtools(
    (set, get) => ({
      ...initialState,
      actions: {
        setLoading: ({ show, dimmed, zIndex }: { show: boolean; dimmed?: boolean; zIndex?: number }) => {
          const { show: currentShow } = get();
          if (currentShow === show) {
            return;
          }

          if (!show) {
            setTimeout(() => {
              set({ ...initialState, show, dimmed, zIndex });
            }, 200);
            return;
          }
          set({ ...initialState, show, dimmed, zIndex });
        },
      },
    }),
    {
      trace: true,
    }
  )
);
